import {
  myFetch
} from "./fetch-config";

const url = "/esdb";

interface ResultType {
  error: null,
  id: number,
  result: any
}
// 交易列表
export function txList(params: any = {}): Promise<ResultType> {
  const body = {
    id: 1,
    method: "Tx.TxList",
    params: params
  };
  return myFetch(url, body);
}

// 交易总条数
export function getTxCount(params: any = {}): Promise<ResultType> {
  const body = {
    id: 1,
    method: "Tx.TxCount",
    params: params
  };
  return myFetch(url, body);
}